/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Model, PolicyModel } from "./policy-model";

export abstract class PolicyFetcher {
   public abstract fetchPolicyModel(): Promise<Model | null>;

   protected static createModel(policy: any): Model | null {
      const settings = policy?.[PolicyModel.BROKER_LIST_KEY]?.[PolicyModel.SETTINGS_KEY];

      if (!settings) {
         return null;
      }

      const commonSetting = settings[PolicyModel.COMMON_SETTING_KEY] ?? {};
      const serverList = settings[PolicyModel.SERVER_LIST_KEY] ?? [];

      if (serverList.length === 0 && Object.keys(commonSetting).length === 0) {
         return null;
      }
      return new Model(serverList, commonSetting);
   }
}
